<template>
  <v-container>
    <v-snackbar
      class="snackbar-top"
      v-model="notification.show"
      :top="true"
      :right="true"
      :color="notification.color"
    >
      {{ notification.message }}
      <v-btn
        fab small outlined
        @click="closeNotification"
      >
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>

    <v-simple-table
      fixed-header
    >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">{{$t('forms.name')}}</th>
            <th class="text-center">{{$t('forms.component')}}</th>
            <th class="text-center">{{$t('forms.category')}}</th>
            <th class="text-center">{{$t('forms.plans')}}</th>
            <th class="text-center">
              <v-btn @click="addVideo" fab small color="primary" :disabled="loading">
                <v-icon>add</v-icon>
              </v-btn>
              <v-btn @click="loadVideos" fab small color="primary" class="ml-2" :disabled="loading">
                <v-icon>refresh</v-icon>
              </v-btn>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="video in videos" :key="video.id">
            <td>{{ video.name }}</td>
            <td class="text-center">
              <v-chip>{{ video.component.name }}</v-chip>
            </td>
            <td class="text-center">
              <v-chip>{{ video.category.name }}</v-chip>
            </td>
            <td class="text-center">
              <v-chip class="ml-1 my-1" v-for="plan in video.plans" :key="plan.id">{{ plan.name }}</v-chip>
            </td>
            <td class="text-center">
              <v-btn-toggle borderless group rounded>
                <v-btn @click="editVideo(video)" fab small :disabled="loading" color="blue accent-1" dark>
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn @click="removeVideo(video)" fab small :disabled="loading" color="red accent-1" dark>
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-btn-toggle>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-dialog width="900" v-model="dialog_form">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{current_video.id ? $t('forms.edit-record', {name: $t('forms.video')}) : $t('forms.create-record', {name: $t('forms.video')})}}
        </v-card-title>
        <v-card-text>
          <v-alert type="error" dismissible v-if="error" class="mt-5">{{error}}</v-alert>
          <v-alert type="success" dismissible v-if="notice" class="mt-5">{{notice}}</v-alert>
          <v-form ref="form" v-model="valid">
            <v-row>
              <v-col cols="7" align="center" class="pt-2">
                <v-row>
                  <v-col cols="4" style="position:relative;">
                    <v-btn
                      @click="openChooseThumbnail"
                      absolute
                      fab
                      x-small
                      top
                      right
                      :disabled="loading"
                      class="mt-8"
                      color="white">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-img :src="current_video.image" width="160" height="90"></v-img>
                  </v-col>
                  <v-col cols="8">
                    <v-file-input
                    v-show="false"
                    id="file-thumbnail"
                    v-model="images.current"
                    ref="fileThumbnail"
                    :rules="images.rule"
                    accept="image/jpeg"
                    @change="changeThumbnail"
                    @clear="changeThumbnail"
                    ></v-file-input>
                    <p class="text-left">
                      {{$t('forms.only-images', {type: 'JPG/JPEG', ratio: '16:9', width: 1280, height: 720, size: '500 Kb'})}}
                    </p>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col cols="12" v-show="!current_video.id">
                    <div class="text-center my-4">
                      <div v-if="file_video.current" class="mb-3">
                        {{file_video.current.name}}
                      </div>
                      <v-btn color="primary" @click="openChooseVideo" :disabled="loading" v-if="!file_video.uploading">
                        {{$t(file_video.current ? 'forms.update-upload-video' : 'forms.upload-video')}}
                      </v-btn>
                      <v-file-input
                        v-show="false"
                        id="file-video"
                        v-model="file_video.current"
                        ref="fileVideo"
                        :rules="file_video.rule"
                        accept="video/mp4"
                        @change="changeVideo"
                        @clear="changeVideo"
                        ></v-file-input>
                    </div>
                    <p v-if="!file_video.current && !file_video.uploading" class="text-left">
                      {{$t('forms.video-description', {type: 'MP4', ratio: '16:9', size: '600 Mb'})}}
                    </p>
                    <p v-else-if="file_video.uploading" color="primary">
                      {{$t('forms.video-uploading-description')}}
                    </p>
                    <p v-else color="primary">
                      {{$t('forms.video-upload-on-save')}}
                    </p>
                    <v-row v-if="file_video.uploading">
                      <v-col cols="12">
                        <p class="text-center mb-0">
                          {{$t(file_video.uploading === 100 ? 'results.video-uploaded' : 'forms.uploading-video')}}
                        </p>
                      </v-col>
                      <v-col cols="12" class="text-left">
                        <v-progress-linear
                        buffer-balue=100
                        rounded
                        :value="file_video.uploading"
                        color="light-blue"
                        ></v-progress-linear>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" v-show="current_video.id">
                    <video
                      id="video-player"
                      ref="videoPlayer"
                      class="video-js"
                    >
                    </video>
                    <p class="text-left mt-1">
                      <v-icon>info</v-icon>
                      {{$t('forms.video-cannot-update')}}
                    </p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="5">
                <v-text-field
                  :label="$t('forms.name')"
                  type="text"
                  v-model="current_video.name"
                  :rules="[v => !!v ||  this.$t('forms.is-required', {name: this.$t('forms.name')})]"
                  required
                ></v-text-field>

                <v-textarea
                  solo
                  :label="$t('forms.description')"
                  v-model="current_video.description"
                  :rules="[v => !!v ||  this.$t('forms.is-required', {name: this.$t('forms.description')})]"
                  required
                ></v-textarea>

                <v-select
                  :label="$t('forms.component')"
                  v-model="current_video.component"
                  :items="components"
                  item-text="name"
                  item-value="id"
                  :rules="[v => !!v ||  this.$t('forms.is-required', {name: this.$t('forms.component')})]"
                  required
                  v-on:change="changeComponent"
                ></v-select>

                <v-select
                  :label="$t('forms.category')"
                  v-model="current_video.category"
                  :items="categories_component"
                  item-text="name"
                  item-value="id"
                  required
                ></v-select>

                <v-select
                  multiple
                  :label="$t('forms.available-for-plans')"
                  v-model="current_video.plans"
                  :items="plans"
                  item-text="name"
                  item-value="id"
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveVideo" :loading="loading" :disabled="loading">
            {{$t('forms.save')}}
            <template v-slot:loader>
              <span>{{$t('forms.loading-save')}}</span>
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialog_remove" max-width="600">
        <v-card>
            <v-card-title class="headline">{{$t('forms.sure-remove', {name: current_video.name})}}</v-card-title>
            <v-card-text>
                <p>{{$t('forms.sure-remove-description')}}</p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="cancelRemove">
                    {{ $t('forms.no-remove') }}
                </v-btn>
                <v-btn color="red accent-2" dark @click="confirmRemoveVideo">
                    {{ $t('forms.confirm-remove') }}
                </v-btn>
            </v-card-actions>
            <v-overlay
              :value="loading"
              >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-overlay>
        </v-card>
    </v-dialog>

    <v-overlay :value="!loaded" opacity="1" color="white" light absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<style lang="scss">
  .v-snack--top {
      top: 5em !important;
  }
</style>

<script>
import * as service from '@/store/module/video'
import { getUrlImage, getUrlVideo, uploadImage, uploadVideo, removeImage, removeVideo } from '@/store/storage'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

export default {
  data() {
    return {
      player: null,
      videos: [],
      categories: [],
      components: [],
      plans: [],
      categories_component: [],
      valid: false,
      loaded: false,
      loading: false,
      error: null,
      notice: null,
      dialog_form: false,
      dialog_remove: false,
      dialog_resource: false,
      current_video: null,
      notification: {
        color: 'gree',
        show: false,
        message: ''
      },
      images: {
        example: null,
        default: null,
        current: null,
        rule: [v => !v || v.size < 500000 || this.$t('errors.image-size', {size: '500 Kb'})]
      },
      file_video: {
        current: null,
        rule: [
          v => !v || v.size < 300000000 || this.$t('errors.video-size', {size: '300 Mb'}),
          v => !v || v.type === 'video/mp4' || this.$t('errors.video-type', {type: 'MP4'}),
        ],
        uploading: null
      },
      video_options: {
        controls: true,
        autoplay: false,
        preload: 'none',
        width: '100%',
        aspectRatio: '16:9'
      }
    }
  },
  created() {
    this.loadVideos()
    this.loadComponents()
    this.loadPlans()
    this.resetForm()

    getUrlImage(null, 'video', true).then(url => {
      this.images.example = url
    })
  },
  methods: {
    showNotification(success, message) {
      this.notification.message = message
      this.notification.color = success ? 'green' : 'red'
      this.notification.show = true
    },
    closeNotification() {
      this.notification.show = false
      this.notification.message = ''
    },
    loadPlans() {
      service.getDocumentsFromCollection('plans').then(result => {
        this.plans = result
      })
    },
    loadComponents() {
      service.getDocumentsFromCollection('components').then(result => {
        this.components = result
      })
    },
    loadVideos() {
      this.loaded = false
      service.getDocumentsFromCollection('videos', ['component', 'category', 'plans']).then(result => {
        this.videos = result
        this.loaded = true
      })
    },
    resetForm() {
      if (this.player) {
        this.player.reset()
      }
      this.current_video = {
        id: null,
        name: '',
        description: '',
        category: null,
        component: null,
        plans: null,
        image: this.images.example,
        video: null
      }
      this.images.current = null
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    openFormDialog() {
      this.dialog_form = true
    },
    closeFormDialog() {
      this.dialog_form = false
    },
    openRemoveDialog() {
      this.dialog_remove = true
    },
    closeRemoveDialog() {
      this.dialog_remove = false
    },
    removeVideo(video) {
      this.current_video = video
      this.openRemoveDialog()
    },
    cancelRemove() {
      this.closeRemoveDialog()
      this.resetForm()
    },
    confirmRemoveVideo() {
      this.loading = true
      service.removeVideo(this.current_video.id)
        .then(async () => {
          await removeImage(this.current_video.id, 'video')
          await removeVideo(this.current_video.id, 'video')
          this.showNotification(true, this.$t("forms.data-removed"))
          this.cancelRemove()
          this.loadVideos()
          this.loading = false
        })
        .catch(() => {
          this.showNotification(true, this.$t("errors.remove"))
          this.loading = false
        })
    },
    getUrlImage(image) {
      return getUrlImage(image, 'video', true)
    },
    changeComponent() {
      return (
        service.getCategoriesByComponent(this.current_video.component).then(result => {
          this.categories_component = result
          return true
        })
      )
    },
    addVideo() {
      this.resetForm()
      this.openFormDialog()
    },
    loadCurrentVideo() {
      if (!this.player && this.$refs.videoPlayer) {
        this.player = videojs(
          this.$refs.videoPlayer, {
            controls: true,
            autoplay: false,
            preload: 'none',
            width: '100%',
            aspectRatio: '16:9'
          }
        )
      }

      if (this.current_video.poster) {
        this.player.poster(this.current_video.poster)
      }
      this.player.src({ src: this.current_video.video })
    },
    async editVideo(video) {
      this.loading = true
      this.resetForm()

      // Thumbnail
      if (!video.image) {
        video.image = this.images.example
        video.image_loaded = true
      } else if (!video.image_loaded) {
        await getUrlImage(video.image, 'video', true).then(url => {
          video.image = url
          video.image_loaded = true
        })
      }

      // Video
      if (video.video && !video.video_loaded) {
        await getUrlVideo(video.video).then(url => {
          video.video = url
          video.video_loaded = true
        })
      }

      // Set object
      this.current_video = {
        id: video.id,
        name: video.name,
        description: video.description,
        component: video.component.id,
        image: video.image,
        video: video.video,
        poster: video.image_loaded ? video.image : null,
        plans: []
      }
      for (let plan of video.plans) {
        this.current_video.plans.push(plan.id)
      }
      this.changeComponent().then(async () => {
        this.current_video.category = video.category.id
        this.loading = false
        await this.openFormDialog()
        this.loadCurrentVideo()
      })
    },
    openChooseThumbnail() {
      document.getElementById("file-thumbnail").click()
    },
    openChooseVideo() {
      document.getElementById("file-video").click()
    },
    changeThumbnail() {
      if (!this.images.current) {
        this.images.current = null
      }
    },
    changeVideo() {
      if (!this.file_video.current) {
        this.file_video.current = null
        return
      }

      if (!this.$refs.fileVideo.validate() && this.$refs.fileVideo.hasError) {
        this.error = this.$refs.fileVideo.errorBucket.join()
        this.file_video.current = null
        return
      }
      this.error = ''
    },
    saveVideo() {
      if (!this.current_video.id && !this.file_video.current) {
        this.error = this.$t('errors.upload-video')
        this.loading = false
        return
      }
      if (this.$refs.form.validate()) {
        this.loading = true
        this.notice = null
        this.error = null

        let component = service.getDocById('components', this.current_video.component)
        let category = service.getDocById('categories', this.current_video.category)
        let plans = []
        for (let i in this.current_video.plans) {
          plans.push(service.getDocById('plans', this.current_video.plans[i]))
        }
        let video = {
          id: this.current_video.id ? this.current_video.id : null,
          name: this.current_video.name,
          description: this.current_video.description,
          category: category,
          component: component,
          plans: plans
        }

        let action_save = this.current_video.id ? service.updateVideo : service.createVideo
        action_save(video)
        .then(async document => {
          // Upload image
          if (this.images.current) {
            uploadImage(document.id, 'video', this.images.current)
              .then(async result => {
                let success = result.state === 'success'
                this.showNotification(success, success ? this.$t("results.image-uploaded") : this.$t("errors.upload-failed"))
                if (success) {
                  await service.updateVideoThumbnail(document.id)
                }
              })
          }
          // Update video
          if (!this.current_video.id) {
            let uploadTask = uploadVideo(document.id, 'video', this.file_video.current)
            uploadTask
            .on('state_changed', snapshot => {
              let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
              this.file_video.uploading = Math.ceil(progress)
            },
            error => {
              this.showNotification(false, this.$t("errors.upload-failed"))
              this.error = error.message
              this.loading = false
            },
            async () => {
              await service.updateVideoName(document.id)
              this.showNotification(true, this.$t("results.video-uploaded"))
              this.closeFormDialog()
              this.$refs.form.reset()
              this.loading = false
              this.loaded = false
              this.loadVideos()
            })
          } else {
            this.closeFormDialog()
            this.$refs.form.reset()
            this.loading = false
            if (this.player) {
              this.player.reset()
            }
            this.loadVideos()
          }

          // End save process
          this.showNotification(true, this.$t("forms.saved-record"))
        })
        .catch(error => {
          this.error = error.message
          this.loading = false
        })
      } else if (this.$refs.fileThumbnail.hasError){
        this.error = this.$refs.fileThumbnail.messagesToDisplay.join()
        this.loading = false
      }
    }
  }
}
</script>
